export enum DynamicFilterPayloadValue {
  Me = 'me',
  Location = 'location',
  Time = 'time',
  OneOfMyGroups = 'one-of-my-groups',
  LastYear = 'last-year',
  ThisYear = 'this-year',
  NextYear = 'next-year',
  LastMonth = 'last-month',
  ThisMonth = 'this-month',
  NextMonth = 'next-month',
  Yesterday = 'yesterday',
  Today = 'today',
  Tomorrow = 'tomorrow',
  Now = 'now',
  StartOfThisWeek = 'start-of-this-week',
  EndOfThisWeek = 'end-of-this-week',
  StartOfThisMonth = 'start-of-this-month',
  EndOfThisMonth = 'end-of-this-month',
  StartOfThisYear = 'start-of-this-year',
  EndOfThisYear = 'end-of-this-year',
  FirstDayOfThisWeek = 'first-day-of-this-week',
  LastDayOfThisWeek = 'last-day-of-this-week',
}
